import React, { useEffect } from "react";
import { EditProfile } from "../components/molecules/profile/EditProfile";
import { Box } from "@chakra-ui/react";
import { useRoot } from "../context/RootContext";

export let loader = async () => {
  return { type: "profile" };
};
const Profile = () => {
  const { setOpenEditProfile } = useRoot();

  useEffect(() => {
    setOpenEditProfile(true);
    return () => setOpenEditProfile(false); // Clean up when component unmounts
  }, [setOpenEditProfile]);
  return (
    <Box>
      <EditProfile />
    </Box>
  );
};

export default Profile;
